document.addEventListener('DOMContentLoaded', function() {
  // Initialize Swiper
  const comparisonSwiper = new Swiper('.comparison-swiper', {
    slidesPerView: 4,
    spaceBetween: 0,
    freeMode: false,
    grabCursor: true,
    mousewheel: {
      invert: false,
      forceToAxis: true,
    },
    direction: 'horizontal',
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      0: { slidesPerView: 1.2, spaceBetween: 0 },
      600: { slidesPerView: 2, spaceBetween: 0 },
      1024: { slidesPerView: 4, spaceBetween: 0 }
    }
  });

  // Update Swiper on window resize
  let resizeTimeout;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(function() {
      if (comparisonSwiper) comparisonSwiper.update();
      syncAllHeights();
    }, 250);
  });

  // Sync Empty Header Height With Product Headers
  function syncHeaderHeights() {
    const emptyHeader = document.querySelector('.empty-header');
    const firstProductHeader = document.querySelector('.product-header');
    
    if(emptyHeader && firstProductHeader) {
      emptyHeader.style.height = 'auto';
      const productHeaderHeight = firstProductHeader.offsetHeight;
      emptyHeader.style.height = productHeaderHeight + 'px';
    }
  }

  // Sync Product Columns Height With Fixed Attributes
  function syncColumnHeights() {
    const fixedAttributes = document.querySelector('.fixed-attributes');
    const productColumns = document.querySelectorAll('.product-column');

    if(fixedAttributes && productColumns.length > 0) {
      const fixedHeight = fixedAttributes.offsetHeight;
      productColumns.forEach(column => {
        column.style.height = fixedHeight + 'px';
      });
    }
  }

  // Sync All Heights
  function syncAllHeights() {
    syncHeaderHeights();
    syncColumnHeights();
  }

  // Call Height Sync After Initialization and Images Load
  setTimeout(syncAllHeights, 100);
  const productImages = document.querySelectorAll('.product-image');
  productImages.forEach(img => img.addEventListener('load', syncAllHeights));


  

  // Initialize Yotpo Reviews Widget for Comparison Matrix
  const accessToken = "66D64NSwpjqljLxypvgJa1mLC8RzI1wJ8yaeqXSI";
  
  // Find the comparison matrix element
  const comparisonMatrix = document.getElementById('comparison-matrix');
  
  if (comparisonMatrix) {
    // Get all product columns within the comparison matrix
    const productColumns = comparisonMatrix.querySelectorAll('.product-column');
    
    // Process products sequentially instead of in parallel
    async function processProductsSequentially() {
      for (let index = 0; index < productColumns.length; index++) {
        const column = productColumns[index];
        
        // Find the product title within this column
        const titleElement = column.querySelector('.title-length');
        
        if (titleElement) {
          const productTitle = titleElement.textContent.trim();
          
          // Find the review container for this specific product
          const reviewContainer = column.querySelector('.review-stars');
          
          if (reviewContainer) {
            // Get the actual product ID from the data attribute
            const productId = column.getAttribute('data-product-id');
            const productHandle = column.getAttribute('data-product-handle');
            
            if (!productId) {
              // Show a fallback message even if no product ID
              reviewContainer.innerHTML = '<span class="no-product-id">Product ID missing</span>';
            } else {
              // Add a loading state
              reviewContainer.innerHTML = '<span class="loading-reviews">Loading Reviews...</span>';
              
              // Construct Yotpo API endpoint for this product
              const apiUrl = `https://api-cdn.yotpo.com/products/${accessToken}/${productId}/bottomline`;
              
              try {
                // Fetch Yotpo data for this product sequentially
                const response = await fetch(apiUrl, {
                  method: "GET",
                  headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json"
                  }
                });
                
                if (!response.ok) {
                  throw new Error(`HTTP error! Status: ${response.status}`);
                }
                
                const data = await response.json();
                
                // Extract rating and review count
                const avgRating = data?.response?.bottomline?.average_score;
                const totalReviews = data?.response?.bottomline?.total_review;
                
                // Clear existing content and append new Yotpo review data
                reviewContainer.innerHTML = '';
                
                // Always render something, even if no rating data
                // Fix: Check for existence and valid values, not just truthy
                // Also handle case where rating is 0 (valid but falsy)
                if (avgRating !== null && avgRating !== undefined && avgRating > 0) {
                  // Create star display based on rating
                  const fullStars = Math.floor(avgRating);
                  const hasHalfStar = (avgRating % 1) >= 0.5;
                  const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);
                  
                  // Create stars HTML
                  let starsHTML = '';
                  for (let i = 0; i < fullStars; i++) {
                    starsHTML += '<span class="star filled"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M8.58301 5.0957L8.68164 5.32715L8.93164 5.34863L12.9805 5.69141L9.90527 8.35645L9.71484 8.52051L9.77246 8.76562L10.6953 12.7246L7.21484 10.624L7 10.4941L6.78516 10.624L3.30371 12.7246L4.22754 8.76562L4.28516 8.52051L4.09473 8.35645L1.01855 5.69141L5.06836 5.34863L5.31836 5.32715L5.41699 5.0957L7 1.35938L8.58301 5.0957Z" fill="#141415" stroke="#141415" stroke-width="0.833333"/></svg></span>';
                  }
                  if (hasHalfStar) {
                    starsHTML += `
                      <span class="star half">
                        <svg aria-hidden="true" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" width="13" height="13">
                          <defs>
                            <linearGradient id="yotpo_stars_gradient_0.2892143293290924">
                              <stop offset="51%" stop-color="rgba(20,20,21,1)"></stop>
                              <stop stop-opacity="1" offset="51%" stop-color="#FFFFFF"></stop>
                            </linearGradient>
                          </defs>
                          <path style="pointer-events: none;" d="M9 14.118L14.562 17.475L13.086 11.148L18 6.891L11.529 6.342L9 0.375L6.471 6.342L0 6.891L4.914 11.148L3.438 17.475L9 14.118Z" stroke="rgba(20,20,21,1)" fill="url('#yotpo_stars_gradient_0.2892143293290924')"></path>
                        </svg>
                      </span>
                    `;
                  }                  
                  for (let i = 0; i < emptyStars; i++) {
                    starsHTML += '<span class="star empty"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M8.58301 5.0957L8.68164 5.32715L8.93164 5.34863L12.9805 5.69141L9.90527 8.35645L9.71484 8.52051L9.77246 8.76562L10.6953 12.7246L7.21484 10.624L7 10.4941L6.78516 10.624L3.30371 12.7246L4.22754 8.76562L4.28516 8.52051L4.09473 8.35645L1.01855 5.69141L5.06836 5.34863L5.31836 5.32715L5.41699 5.0957L7 1.35938L8.58301 5.0957Z" fill="white" stroke="#141415" stroke-width="0.833333"/></svg></span>';
                  }
                  
                  // Append the complete review display
                  const reviewHTML = `
                    ${starsHTML}
                    <span class="rating-number">${avgRating.toFixed(1)}</span>`;
                  
                  reviewContainer.innerHTML = reviewHTML;
                } else {
                  // Show "No reviews" if no data available
                  const noReviewsHTML = '<span class="no-reviews">No reviews available</span>';
                  reviewContainer.innerHTML = noReviewsHTML;
                }
                
                // Force a reflow to ensure the DOM is updated
                reviewContainer.offsetHeight;
                
              } catch (error) {
                // Handle error case - show error state in review container
                const errorHTML = '<span class="review-error">Reviews unavailable</span>';
                reviewContainer.innerHTML = errorHTML;
              }
              
              // Add a timeout fallback to ensure something always shows
              setTimeout(() => {
                if (reviewContainer.innerHTML.includes('Loading Reviews...')) {
                  reviewContainer.innerHTML = '<span class="timeout-fallback">API timeout - showing placeholder</span>';
                }
              }, 10000); // 10 second timeout
            }
          }
        }
        
        // Add a small delay between API calls to avoid rate limiting
        if (index < productColumns.length - 1) {
          await new Promise(resolve => setTimeout(resolve, 500));
        }
      }
    }
    
    // Start the sequential processing
    processProductsSequentially().catch(error => {
      // Handle any errors in the sequential processing
    });
  }
});